export enum SORT_OPTIONS {
  APPLICATION_DATE = 'application_date',
  OVERALL_SCORE = 'overall_score',
  CREATION_DATE = 'creation_date',
}

export enum SORT_TYPE {
  ASC = 'asc',
  DESC = 'desc',
}
